"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = exports.defaultHttpClient = void 0;
const http_client_1 = require("@invent/http-client");
// using localforage/wlabel token key as default
function getToken() {
    return __awaiter(this, void 0, void 0, function* () {
        const token = localStorage.getItem('whitelabel/token');
        const parsedToken = token ? JSON.parse(token) : '';
        return parsedToken;
    });
}
exports.defaultHttpClient = (0, http_client_1.getHttpClient)({
    getToken
});
const httpClient = (...args) => {
    if (!window.sharedHostGateway.httpClient) {
        throw new Error('SharedHostGateway Error: httpClient is not registered');
    }
    return window.sharedHostGateway.httpClient(...args);
};
exports.httpClient = httpClient;
